export default {
  title: 'CGC Overseas Construction Group',
  title_ja: 'CGC海外建設グループ',
  title_zh: 'CGC海外建筑集团',
  role: 'Business Assistant & Financial Administrator',
  role_ja: 'ビジネスアシスタント・財務管理者',
  role_zh: '业务助理兼财务管理员',
  location: 'Abeokuta, Nigeria & Abuja HQ',
  location_ja: 'ナイジェリア・アベオクタ＆アブジャ本部',
  location_zh: '尼日利亚阿贝奥库塔和阿布贾总部',
  period: 'Mar 2021 – Jul 2022',
  slug: 'cgc-overseas',
  summary: 'Managed business operations and financial administration for water supply projects worth over $13.5M in Nigeria.',
  summary_ja: 'ナイジェリアで総額1,350万ドル以上の給水プロジェクトの事業運営と財務管理を担当。',
  summary_zh: '在尼日利亚管理价值超过1350万美元的供水项目的业务运营和财务管理。',
  achievements: [
    'Built relationships with state stakeholders including the Water Resources SA, GM, PIU engineers, and SGI supervisors',
    'Organized bi-weekly project meetings and managed over 100+ business correspondences',
    'Drafted contracts with subcontractors (sand supply, drilling, dorms, etc.)',
    'Resolved critical issues such as passport disputes and tax audits through diplomatic negotiation',
    'Handled daily operations of project bank accounts and cash flow',
    'Managed payroll and HR affairs for drivers, cleaners, security, and local staff',
    'Supervised six military guards on-site; maintained relations with local COVID-19 response officials'
  ],
  achievements_ja: [
    '水資源局、GM、PIUエンジニア、SGI監督者などの州の関係者との関係を構築',
    '隔週のプロジェクト会議を開催し、100件以上のビジネス通信を管理',
    '下請け業者（砂の供給、掘削、寮など）との契約書を作成',
    '外交的交渉を通じてパスポート紛争や税務監査などの重要な問題を解決',
    'プロジェクト銀行口座とキャッシュフローの日常業務を処理',
    '運転手、清掃員、警備員、現地スタッフの給与計算と人事業務を管理',
    '現場で6人の軍事警備員を監督し、地元のCOVID-19対応当局との関係を維持'
  ],
  achievements_zh: [
    '建立与各州利益相关者的关系，包括水资源局、总经理、PIU工程师和SGI主管',
    '组织双周项目会议并管理100多份商务信函',
    '起草与分包商（沙子供应、钻探、宿舍等）的合同',
    '通过外交谈判解决护照纠纷和税务审计等关键问题',
    '处理项目银行账户和现金流的日常运营',
    '管理司机、清洁工、保安和当地员工的工资和人力资源事务',
    '监督现场六名军事警卫；维持与当地COVID-19应对官员的关系'
  ],
  tags: ['international', 'construction', 'finance', 'project-management'],
  metadata: {
    type: 'Construction Project',
    type_ja: '建設プロジェクト',
    type_zh: '建设项目',
    field: 'Water Resources',
    field_ja: '水資源',
    field_zh: '水资源',
    teamSize: 'Medium (50-100)',
    teamSize_ja: '中規模 (50-100人)',
    teamSize_zh: '中型 (50-100人)',
    role: 'Business Assistant & Financial Administrator',
    role_ja: 'ビジネスアシスタント・財務管理者',
    role_zh: '业务助理兼财务管理员',
    projectValue: '$13.5M+',
    projectValue_ja: '1,350万ドル以上',
    projectValue_zh: '1350万美元以上'
  },
  projects: [
    {
      name: 'Abeokuta Urban Water Supply Project – LOT1',
      name_ja: 'アベオクタ都市給水プロジェクト – LOT1',
      name_zh: '阿贝奥库塔城市供水项目 – LOT1',
      value: '$6.19M',
      value_ja: '619万ドル',
      value_zh: '619万美元'
    },
    {
      name: 'Abeokuta Pipeline Project – LOT2',
      name_ja: 'アベオクタパイプラインプロジェクト – LOT2',
      name_zh: '阿贝奥库塔管道项目 – LOT2',
      value: '$7.4M',
      value_ja: '740万ドル',
      value_zh: '740万美元'
    }
  ],
  // For future detailed content
  getContent: () => import('../content/cgc-overseas.md')
} 